import {EditorState, Transaction} from "prosemirror-state";


import {schema} from "../Editor/module/config/schema";


export const docIsEmpty = (state: EditorState | Transaction | null) => {
    const content = state && state.doc.content;
    return content && (
        content.childCount === 1
        && content.firstChild!.type === schema.nodes.paragraph
        && content.firstChild!.nodeSize === 2
    );
}
